export const EVENT_TYPE = {
  GANTT_TASK_RESOURCE_COUNT_UPDATE: 'GANTT_TASK_RESOURCE_COUNT_UPDATE'
};
